
import { AuthService } from "@/services/auth-service";
import { UserConfigService } from "@/services/user-config-service";
import { ToolbarService } from "@/services/toolbar-service";
import { DrawerLink } from "@/utils/drawer-links/drawer-link";
import { DrawerLinkWrapper } from "@/utils/drawer-links/drawer-link-wrapper";
import { LINDUA_ICONS } from "@/utils/drawer-links/lindua-icons";
import { FA_ICONS } from "@/utils/drawer-links/icon-utils";
import AppIcon from "@/components/common/AppIcon.vue";
import { ConfirmResult } from "winfakt-vue-components";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			settings: new DrawerLinkWrapper(),
			saving: false,
			modalOpen: false,
			modalIsNew: false,
			modalGroupKey: "",
			modalIndex: -1,
			editingLink: new DrawerLink(),
			iconSearch: ""
		};
	},
	computed: {
		groups(): {key: string; label: string}[] {
			return [
				{ key: "Top", label: this.$ct("group-top").toString() },
				{ key: "Contacts", label: this.$ct("group-contacts").toString() },
				{ key: "Products", label: this.$ct("group-products").toString() },
				{ key: "Sales", label: this.$ct("group-sales").toString() },
				{ key: "Buy", label: this.$ct("group-buy").toString() },
				{ key: "Financial", label: this.$ct("group-financial").toString() },
				{ key: "Tools", label: this.$ct("group-tools").toString() },
				{ key: "Bottom", label: this.$ct("group-bottom").toString() },
			];
		},
		filteredIcons(): string[] {
			const search = (this.iconSearch || "").toLowerCase();
			if (!search) return [];
			return [...LINDUA_ICONS, ...FA_ICONS].filter(i => i.toLowerCase().includes(search)).slice(0, 50);
		}
	},
	methods: {
		getLinks(groupKey: string): DrawerLink[] {
			return (this.settings as any)[groupKey] || [];
		},
		addLink(groupKey: string) {
			this.editingLink = new DrawerLink();
			this.editingLink.Name = this.$ct("new-link").toString();
			this.modalGroupKey = groupKey;
			this.modalIndex = -1;
			this.modalIsNew = true;
			this.iconSearch = "";
			this.modalOpen = true;
		},
		editLink(groupKey: string, index: number) {
			const link = this.getLinks(groupKey)[index];
			this.editingLink = new DrawerLink(link.getJSON());
			this.modalGroupKey = groupKey;
			this.modalIndex = index;
			this.modalIsNew = false;
			this.iconSearch = "";
			this.modalOpen = true;
		},
		async removeLink() {
			const confirm = await this.$wf.confirm(
				this.$ct("confirm-delete"),
				this.$ct("common.yes"),
				this.$ct("common.no"),
				this.$ct("delete"),
				"warning"
			);
			if (confirm !== ConfirmResult.YES) return;
			(this.settings as any)[this.modalGroupKey].splice(this.modalIndex, 1);
			await this.persist();
		},
		onIconSearch(value: string) {
			this.iconSearch = value;
		},
		selectIcon(iconName: string) {
			this.editingLink.Icon = iconName;
		},
		cancelModal() {
			this.modalOpen = false;
		},
		async confirmModal() {
			if (this.modalIsNew) {
				(this.settings as any)[this.modalGroupKey].push(this.editingLink);
			} else {
				const links = (this.settings as any)[this.modalGroupKey];
				this.$set(links, this.modalIndex, this.editingLink);
			}
			await this.persist();
		},
		async persist() {
			this.saving = true;
			try {
				this.settings = await UserConfigService.setDrawerLinkSettings(this.settings);
				this.modalOpen = false;
				this.$wf.notify(this.$ct("save-success"), "success", 3000, "check");
			} catch (err) {
				this.loadSettings();
				throw err;
			} finally {
				this.saving = false;
			}
		},
		loadSettings() {
			this.settings = UserConfigService.getDrawerLinkSettings();
		}
	},
	created() {
		if (!AuthService.isDevModeEnabled) {
			this.$router.replace("/settings");
			return;
		}
		ToolbarService.title = "views.DrawerLinksSettings.title";
		this.loadSettings();
	},
	components: { AppIcon },
	i18nEx: {
		componentPrefix: "views.DrawerLinksSettings"
	}
});
